export default {
  required: 'Dieses Feld ist ein Pflichtfeld',
  correct_email: 'Bitte geben Sie eine korrekte E-Mail-Adresse ein',
  correct_address: 'Addresse konnte nicht gefunden werden',
}
